import React from "react";

import { QuestionInteractionOutro } from "@/service/Model";
import {
  QuestionConfigData,
  QuestionSet,
  TealiumAgeRange,
  TealiumApi,
  TealiumApiService,
  TealiumGender,
  TealiumIncomeRange,
} from "@/service/Tealium";
import TrackingService from "@/service/Tracking";
import Svg from "@/styles/Svg";
import { Enum } from "@/utils/transform";

import { OutroPropsExtented } from "../index";
import {
  OutroFeedback,
  OutroFeedbackIcon,
  QuestionFieldset,
  QuestionOption,
  QuestionTitle,
} from "../styles";

interface QuestionProps extends OutroPropsExtented, QuestionInteractionOutro {
  title?: string;
  icons: IIcons;
  tealiumConfig: ITealium;
  onClose: () => void;
}

interface QuestionState {
  voted: boolean;
}

export class Question extends React.Component<QuestionProps, QuestionState> {
  private tealiumApi: TealiumApi;
  private doTracking: boolean;

  public constructor(props: QuestionProps) {
    super(props);
    this.state = {
      voted: false,
    };
    this.tealiumApi = new TealiumApiService();
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.doTracking = true;
  }

  public componentDidMount(): void {
    if (this.doTracking) {
      TrackingService.getInstance().trackOnOutroImpression();
    }
  }

  public render(): JSX.Element {
    const { voted } = this.state;
    const {
      genderRequest,
      ageRequest,
      incomeRequest,
      tealiumConfig,
    } = this.props;

    if (voted) {
      return <div>{this.renderThankYou()}</div>;
    }

    if (genderRequest && !tealiumConfig.gender) {
      return <div>{this.renderRequest(QuestionConfigData.gender)}</div>;
    } else if (ageRequest && !tealiumConfig.age_range) {
      return <div>{this.renderRequest(QuestionConfigData.age_range)}</div>;
    } else if (incomeRequest && !tealiumConfig.income_range) {
      return <div>{this.renderRequest(QuestionConfigData.income_range)}</div>;
    } else {
      // demographic data is completed in tealiumConfig
      this.doTracking = false;
      return <React.Fragment />;
    }
  }

  private renderRequest(questionSet: QuestionSet): JSX.Element {
    const htmlOptions = questionSet.options.map((option: any, i: number) => (
      <QuestionOption
        key={i}
        onClick={(e: any) => this.handleOptionClick(e, option.value)}
      >
        {option.text}
      </QuestionOption>
    ));

    return (
      <div>
        <QuestionTitle>{questionSet.question}</QuestionTitle>
        <QuestionFieldset>{htmlOptions}</QuestionFieldset>
      </div>
    );
  }

  private renderThankYou(): JSX.Element {
    return (
      <OutroFeedback>
        <OutroFeedbackIcon success={true}>
          <Svg contents={this.props.icons.Success} height={65} width={65} />
        </OutroFeedbackIcon>
        <h3>VIELEN DANK FÜR IHRE TEILNAHME</h3>
      </OutroFeedback>
    );
  }

  private handleOptionClick(e: Event, value: any): void {
    e.stopPropagation();
    e.preventDefault();
    const {
      tealiumConfig,
      genderRequest,
      ageRequest,
      incomeRequest,
    } = this.props;
    if (!tealiumConfig) {
      return;
    }
    const query: ITealium = {
      tealium_account: tealiumConfig.tealium_account,
      tealium_profile: tealiumConfig.tealium_profile,
      tealium_vid: tealiumConfig.tealium_vid,
      is_premium_user: tealiumConfig.is_premium_user,
    };

    if (genderRequest && Enum.contains(TealiumGender, value)) {
      query.gender = value;
    } else if (ageRequest && Enum.contains(TealiumAgeRange, value)) {
      query.age_range = value;
    } else if (incomeRequest && Enum.contains(TealiumIncomeRange, value)) {
      query.income_range = value;
    } else {
      return;
    }

    this.tealiumApi.send(query);
    this.setState({ voted: true });
    TrackingService.getInstance().trackOnOutroClick();
  }

  private handleCloseClick(e: Event): void {
    e.stopPropagation();
    this.props.onClose();
  }
}

export default Question;
